const lagoon = {
  id: 'lagoon',
  displayName: 'Lagoon',
  enabled: true,
  graph: {
    writeSample: '#7C9CDC', writeTrend: '#2A5CB0', writeMax: '#BCD2EF',
    writeMin: '#BFD5EA', writeLatency: '#7C9CDC',
    readSample: '#AACC00', readTrend: '#008080', readMax: '#6B8E23',
    readMin: '#228B22', readLatency: '#AACC00',
  },
  canvas: {
    chartBg: '#2B2B2B', gridColor: '#444444', textColor: '#ADB5BD',
  },
};
export default lagoon;
